import { render, staticRenderFns } from "./CadastroDepartamento.vue?vue&type=template&id=4339e2a0"
import script from "./CadastroDepartamento.vue?vue&type=script&lang=js"
export * from "./CadastroDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports